import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=680d3701&scoped=true"
import script from "./IdCard.vue?vue&type=script&lang=js"
export * from "./IdCard.vue?vue&type=script&lang=js"
import style0 from "./IdCard.vue?vue&type=style&index=0&id=680d3701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d3701",
  null
  
)

export default component.exports